import { render, staticRenderFns } from "./RoomUnlockedChatMessage.htm?vue&type=template&id=778c6439&scoped=true&"
import script from "./RoomUnlockedChatMessage.ts?vue&type=script&lang=js&"
export * from "./RoomUnlockedChatMessage.ts?vue&type=script&lang=js&"
import style0 from "./RoomUnlockedChatMessage.scss?vue&type=style&index=0&id=778c6439&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778c6439",
  null
  
)

export default component.exports